module.exports = __webpack_public_path__ + "img/tasos.4b4c57e7.jpeg";